export default __webpack_public_path__ + "static/media/8.71762fc2.jpg";